import React from "react";
import { Stack, Typography } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import ContactPageOutlinedIcon from "@mui/icons-material/ContactPageOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import { Link } from "react-router-dom";

const AdminDrawer = ({ page }) => {
  return (
    <Stack spacing={4}>
      <Link to="/admin/dashboard">
        <Stack
          direction="row"
          spacing={1}
          style={page == "Home" ? { borderRight: "5px solid #7a7a80" } : null}
        >
          <HomeOutlinedIcon />
          <Typography>Home</Typography>
        </Stack>
      </Link>

      <Link to="/admin/registration-manager">
        <Stack
          direction="row"
          spacing={1}
          style={
            page == "Registration Manager"
              ? { borderRight: "5px solid #7a7a80" }
              : null
          }
        >
          <HowToRegOutlinedIcon />
          <Typography>Registration Manager</Typography>
        </Stack>
      </Link>

      {/* <Stack
        direction="row"
        spacing={1}
        style={
          page == "Disputes Manager"
            ? { borderRight: "5px solid #7a7a80" }
            : null
        }
      >
        <AttachMoneyOutlinedIcon />
        <Typography>Disputes Manager</Typography>
      </Stack> */}

      {/* <Stack
        direction="row"
        spacing={1}
        style={
          page == "Security Manager"
            ? { borderRight: "5px solid #7a7a80" }
            : null
        }
      >
        <GppGoodOutlinedIcon />
        <Typography>Security Manager</Typography>
      </Stack> */}

      <Link to="/admin/HR-manager">
        <Stack
          direction="row"
          spacing={1}
          style={
            page == "HR Manager" ? { borderRight: "5px solid #7a7a80" } : null
          }
        >
          <ContactPageOutlinedIcon />
          <Typography>HR Manager</Typography>
        </Stack>
      </Link>

      <Link to="/admin/Personal-Info">
        <Stack
          direction="row"
          spacing={1}
          style={
            page == "Personal Info"
              ? { borderRight: "5px solid #7a7a80" }
              : null
          }
        >
          <SettingsOutlinedIcon />
          <Typography>Personal Info</Typography>
        </Stack>
      </Link>
      <Link to="/admin/Categories-Manager">
        <Stack
          direction="row"
          spacing={1}
          style={
            page == "Categories Manager"
              ? { borderRight: "5px solid #7a7a80" }
              : null
          }
        >
          <CategoryOutlinedIcon />
          <Typography>Categories Manager</Typography>
        </Stack>
      </Link>
      <Link to="/admin/admin-manager">
        <Stack
          direction="row"
          spacing={1}
          style={
            page == "Admin Manager"
              ? { borderRight: "5px solid #7a7a80" }
              : null
          }
        >
          <AdminPanelSettingsOutlinedIcon />
          <Typography>Admin Manager</Typography>
        </Stack>
      </Link>
      <Link to="/admin/disputes-manager">
        <Stack
          direction="row"
          spacing={1}
          style={
            page == "Disputes Manager"
              ? { borderRight: "5px solid #7a7a80" }
              : null
          }
        >
          <AttachMoneyOutlinedIcon />
          <Typography>Disputes Manager</Typography>
        </Stack>
      </Link>
      <Link to="/admin/user-stats">
        <Stack
          direction="row"
          spacing={1}
          style={
            page == "User Stats" ? { borderRight: "5px solid #7a7a80" } : null
          }
        >
          <QueryStatsIcon />
          <Typography>User Stats</Typography>
        </Stack>
      </Link>
    </Stack>
  );
};

export default AdminDrawer;
